var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "middle",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _vm.latestFeedback && !_vm.isSelected
        ? _c("div", { staticClass: "highlighted-feedback" }, [
            _c("div", [
              _c("p", [
                _vm._v(
                  '\n        "' +
                    _vm._s(_vm.latestFeedback.description) +
                    '"\n      '
                )
              ])
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "profile_picture",
              attrs: { src: "/static/person.svg" }
            })
          ])
        : _c(
            "div",
            {
              staticClass: "biography-content",
              class: { "full-biography": _vm.isSelected }
            },
            [
              _c("h4", [_vm._v("sobre o profissional:")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _vm.bio || "O profissional não possui uma biografia."
                    ) +
                    "\n  "
                )
              ])
            ]
          ),
      _vm._v(" "),
      _vm.isSelected
        ? _c("div", { staticClass: "actions" }, [
            _c("div", { staticClass: "feedbacks" }, [
              _vm._v("\n      Avaliações\n    ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSelected
        ? _c("div", { staticClass: "feedback-content" }, [_c("Feedbacks")], 1)
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df49cdc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df49cdc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Card/Profile.vue
// module id = null
// module chunks = 